import { Text, TextProps } from '@chakra-ui/react'
import { Fragment } from 'react'

import { IResolvedArtMeta } from './artFieldHelpers'

interface IArtMetaInlineProps extends TextProps {
  meta: IResolvedArtMeta[]
}

/**
 * One-line "value · value" preview of an artwork's answers (ABRA-73).
 * Unanswered optional fields are still shown ("Campo não respondido") but
 * rendered muted/italic so they read differently from real answers.
 */
export default function ArtMetaInline({ meta, ...textProps }: IArtMetaInlineProps) {
  return (
    <Text {...textProps}>
      {meta.map((item, index) => (
        <Fragment key={index}>
          {index > 0 && ' · '}
          <Text as="span" fontStyle={item.answered ? undefined : 'italic'} opacity={item.answered ? 1 : 0.65}>
            {item.value}
          </Text>
        </Fragment>
      ))}
    </Text>
  )
}
